(function () {
  // ── Wait for DOM ──
  function init() {
    const bar = document.getElementById('sticky-atc-bar');
    const stickyBtn = document.getElementById('sticky-atc-btn');
    const stickyPrice = document.getElementById('sticky-atc-price');

    if (!bar) {
      console.warn('[StickyATC] #sticky-atc-bar not found in DOM.');
      return;
    }

    // ── 1. IntersectionObserver — find original ATC button ──
    const originalATC =
      document.querySelector('.product-form__submit') ||
      document.querySelector('[name="add"]') ||
      document.querySelector('button[type="submit"].btn') ||
      document.querySelector('.btn-addtocart') ||
      document.querySelector('product-form button[type="submit"]');

    if (originalATC) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              bar.classList.remove('is-visible');
              bar.setAttribute('aria-hidden', 'true');
            } else {
              bar.classList.add('is-visible');
              bar.setAttribute('aria-hidden', 'false');
            }
          });
        },
        { threshold: 0.2 } // lowered from 0.5 — triggers earlier
      );
      observer.observe(originalATC);
    } else {
      console.warn('[StickyATC] Could not find original ATC button. Check your selector.');
    }

    // ── 2. Money formatter ──
    function formatMoney(cents) {
      return (cents / 100).toLocaleString('en-AU', {
        style: 'currency',
        currency: 'AUD',
      });
    }

    // ── 3. Update sticky bar UI from a variant object ──
    function updateFromVariant(variant) {
      if (!variant) return;

      if (stickyPrice) {
        let priceHTML = '';

        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceHTML += `<span class="sticky-atc-bar__compare-price">${formatMoney(variant.compare_at_price)}</span> `;
        }

        priceHTML += formatMoney(variant.price);
        stickyPrice.innerHTML = priceHTML;
      }

      if (stickyBtn) {
        if (variant.available) {
          stickyBtn.disabled = false;
          stickyBtn.textContent = 'ADD TO CART →';
          stickyBtn.dataset.variantId = variant.id;
        } else {
          stickyBtn.disabled = true;
          stickyBtn.textContent = 'Sold Out';
          stickyBtn.dataset.variantId = variant.id;
        }
      }
    }

    // ── 4. Variant change — native select (older themes) ──
    document.addEventListener('change', function (e) {
      const isVariantInput =
        e.target.matches('[name="id"]') ||
        e.target.closest('variant-selects') ||
        e.target.closest('variant-radios');

      if (!isVariantInput) return;

      const variantId =
        e.target.value ||
        document.querySelector('[name="id"]')?.value;

      if (!variantId || !window.stickyATCProduct) return;

      const variant = window.stickyATCProduct.variants.find(
        (v) => v.id === parseInt(variantId, 10)
      );
      updateFromVariant(variant);
    });

    // ── 5. Variant change — Dawn / modern themes use custom events ──
    // Dawn fires 'variant:changed' on the product form
    document.addEventListener('variant:changed', function (e) {
      const variant = e.detail?.variant;
      if (variant) updateFromVariant(variant);
    });

    // Some themes fire this instead
    document.addEventListener('variantChange', function (e) {
      const variant = e.detail?.variant;
      if (variant) updateFromVariant(variant);
    });

    // Fallback: poll the hidden [name="id"] input for themes
    // that update it silently without firing events
    let lastVariantId = document.querySelector('[name="id"]')?.value;
    setInterval(function () {
      const currentId = document.querySelector('[name="id"]')?.value;
      if (currentId && currentId !== lastVariantId) {
        lastVariantId = currentId;
        if (!window.stickyATCProduct) return;
        const variant = window.stickyATCProduct.variants.find(
          (v) => v.id === parseInt(currentId, 10)
        );
        updateFromVariant(variant);
      }
    }, 300);

    // ── 6. Add to Cart via AJAX ──
    if (stickyBtn) {
      stickyBtn.addEventListener('click', async function () {
        const variantId =
          this.dataset.variantId ||
          document.querySelector('[name="id"]')?.value;

        if (!variantId) {
          console.warn('[StickyATC] No variant ID found for ATC.');
          return;
        }

        const originalText = stickyBtn.textContent;
        stickyBtn.textContent = 'Adding...';
        stickyBtn.disabled = true;

        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 }),
          });

          if (res.ok) {
            stickyBtn.textContent = 'Added ✓';

            // ── Dawn CartDrawer: open it ──
           const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer) {
              // Fetch updated cart sections the way Dawn does it natively
              const sectionsToRender = cartDrawer.getSectionsToRender?.();
              const sectionIds = sectionsToRender
                ? sectionsToRender.map((s) => s.id).join(',')
                : 'cart-drawer';

              fetch(`/?sections=${sectionIds}`)
                .then((r) => r.json())
                .then((sections) => {
                  // Let Dawn's own renderContents handle the HTML swap
                  if (cartDrawer.renderContents) {
                    cartDrawer.renderContents({ sections });
                  }
                  cartDrawer.open?.();
                })
                .catch(() => {
                  // Fallback: just open without re-rendering
                  cartDrawer.open?.();
                });
            } else {
              // No cart drawer found — fallback events
              document.dispatchEvent(new CustomEvent('cart:refresh'));
              document.dispatchEvent(new CustomEvent('cart:updated'));
            }

            // Update cart bubble count
            fetch('/cart.js')
              .then((r) => r.json())
              .then((cart) => {
                const countEls = document.querySelectorAll(
                  '[data-cart-count], .cart-count, #cart-count, .cart-count-bubble'
                );
                countEls.forEach((el) => {
                  el.textContent = cart.item_count;
                });

                // Dawn uses this attribute on the cart icon bubble
                document.querySelectorAll('cart-icon-bubble').forEach((el) => {
                  el.setAttribute('data-cart-count', cart.item_count);
                });
              });

            setTimeout(() => {
              stickyBtn.textContent = originalText;
              stickyBtn.disabled = false;
            }, 2000);

          } else {
            const err = await res.json();
            console.error('[StickyATC] Cart error:', err);
            stickyBtn.textContent = err.description || 'Error — Try Again';
            stickyBtn.disabled = false;
          }
        } catch (err) {
          console.error('[StickyATC] Fetch failed:', err);
          stickyBtn.textContent = 'Error — Try Again';
          stickyBtn.disabled = false;
        }
      });
    }

  }

  // Run after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
